// Use only in search.php

// Check/uncheck all cb's with given name
window["jqCheckAll"] = function (name, checked) {
    $("INPUT[@name=" + name + "][type='checkbox']")
        .attr('checked', checked ? true : false);
}

window["fnSearchStart"] = function () {
    $('.sCClpsd').show();
    $('.sCExpnd').show();
    $('.sCClpsd .title, .sCExpnd .title').click(function () {
        $(this).siblings('.sCFieldBody').toggle();
        const b = $(this).children('.expBtn');
        b.html(b.html() == '+' ? '-' : '+');
    });

    $('.search-field-country .selElem').change(function () {
        $('.search-field-continents input:checked').attr('checked', false);
    });
    $('#sCMinArr').click(function () {
        $('.search-fields').hide();
        $('#sCMinArr').hide();
        $('#sCMinimized').show();
        $('#sCCtrlFlag').val(0);
    });
    $('#sCMinimized').click(function () {
        $('#sCMinimized').hide();
        $('.search-fields').show();
        $('#sCCtrlFlag').val(1);
        $('#sCMinArr').show();
    });

    // Auto-save filters on form submit
    $('.search-form').on('submit', function() {
        var data = escape($(this).serialize());
        save_def('search', data);
    });

    $('#sCReset').click(function () {
        $("#sCReset").replaceWith('<span id="sCReseting" class="sSaving text-zinc-400">Resetting...</span>');
        save_def('search_reset', '',
            function (d) {
                $("#sCReseting").replaceWith('<span class="sSaved text-zinc-400">Done</span>');
                window.location.href = '/app/search';
            }
        );
    });

}

if ((new RegExp('/app/search')).test(window.location.href)) {
    $(fnSearchStart);
    
    // SearchFilters is included in the webpack bundle
    // If it's not available immediately, something is wrong with the build
    let retryCount = 0;
    const MAX_RETRIES = 10; // Max 1 second wait (10 * 100ms)

    function initializeSearchFilters() {
        if (typeof SearchFilters !== 'undefined') {
            new SearchFilters();
        } else if (retryCount < MAX_RETRIES) {
            retryCount++;
            setTimeout(initializeSearchFilters, 100);
        } else {
            console.error('SearchFilters not found in webpack bundle after ' + MAX_RETRIES + ' attempts. Check webpack configuration.');
        }
    }

    // Try to initialize immediately, or wait if not ready
    initializeSearchFilters();
}

window.updateSearchViewMode = (mode) => {
    $('.search-form').find('input[name="viewMode"]').val(mode);
    $('.search-form').submit();
}

// Store timeout reference to prevent memory leaks
let viewModeTimeout = null;

// Show loading skeleton based on the view mode being switched to
window.showSearchLoadingState = (mode) => {
    const $container = $('.search-results-container');
    const $results = $('.search-results');
    
    // Hide all skeletons first
    $('.search-skeleton').addClass('hidden').removeClass('absolute inset-0 z-10 bg-gray-50');
    
    // Fade out current results
    $results.animate({ opacity: 0.3 }, 200);
    
    // Show the appropriate skeleton based on mode
    const skeletonClass = mode === 'grid' ? '.search-skeleton-grid' : '.search-skeleton-list';
    
    const $skeleton = $container.find(skeletonClass);
    
    // Use Tailwind classes instead of inline styles
    $skeleton
        .addClass('absolute inset-0 z-10 bg-gray-50')
        .attr('aria-busy', 'true')
        .attr('aria-label', 'Loading search results');
    
    // Show skeleton with fade effect
    $skeleton.removeClass('hidden').hide().fadeIn(200);
    
    // Announce to screen readers
    if (window.ariaLiveRegion) {
        window.ariaLiveRegion.text('Loading search results...');
    }
}

// Initialize selectize on country dropdowns if available
document.addEventListener('DOMContentLoaded', function() {
    try {
        if (typeof $.fn.selectize !== 'undefined') {
            // Location dropdown
            $('.location-country').selectize({
                plugins: ['remove_button'],
                delimiter: ',',
                persist: false,
                placeholder: 'Select countries...',
                allowEmptyOption: true
            });

            // Home country dropdown
            $('.home-country-select').selectize({
                plugins: ['remove_button'],
                delimiter: ',',
                persist: false,
                placeholder: 'Select countries...',
                allowEmptyOption: true
            });

            // Languages dropdown
            $('.language-select').selectize({
                plugins: ['remove_button'],
                delimiter: ',',
                persist: false,
                placeholder: 'Select languages...',
                allowEmptyOption: true
            });
        }
    } catch (e) {
        console.warn('Selectize not available or error initializing dropdowns:', e);
    }
});

// IMPORTANT: We use a custom ready-state check instead of $(function) because
// in this environment, jQuery's ready handler does not execute reliably when
// scripts are loaded with the defer attribute. This pattern ensures event
// handlers are attached even if jQuery loads after the DOM is ready.
let checkReadyRetryCount = 0;
const CHECK_READY_MAX_RETRIES = 20; // 1 second max (20 * 50ms)

(function checkReady() {
    if (typeof $ !== 'undefined' && (document.readyState === 'complete' || document.readyState === 'interactive')) {

        // Auto-submit is disabled for filter controls - users should click Apply
        // Only auto-submit for view mode and sort changes (which are immediate actions)
        $('.search-form').on('change', 'input[name="viewMode"], input[name="sort"]', function(e) {
            $('.search-form').submit();
        });

        // Handle view mode button clicks
        $('[data-view-mode]').on('click', function(e) {
            e.preventDefault();
            const mode = $(this).data('view-mode');

            // Clear any existing timeout
            if (viewModeTimeout) {
                clearTimeout(viewModeTimeout);
            }

            // Show loading state
            showSearchLoadingState(mode);

            // Small delay to ensure loading state is visible
            viewModeTimeout = setTimeout(() => {
                updateSearchViewMode(mode);
                viewModeTimeout = null;
            }, 100);
        });

        // Handle bookmark toggle clicks
        $(document).on('click', '[data-bookmark-toggle]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const $btn = $(this);
        const userId = $btn.data('user-id');
        const isBookmarked = $btn.data('bookmarked') === true || $btn.data('bookmarked') === 'true';
        
        // Disable button and show loading state
        $btn.prop('disabled', true);
        const $icon = $btn.find('i');
        const originalClasses = $icon.attr('class') || '';
        $icon.attr('class', 'fas fa-spinner fa-spin text-gray-400');
        
        // Get CSRF token
        const csrfToken = $('meta[name="csrf_token"]').attr('content') || 
                         $('input[name="csrf_token"]').val();
        
        // Make AJAX request
        $.ajax({
            url: '/app/bookmarks/toggle',
            method: 'POST',
            data: {
                user_id: userId,
                csrf_token: csrfToken
            },
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .done(function(response) {
            if (response.success) {
                // Update button state
                const newIsBookmarked = response.is_bookmarked;
                $btn.data('bookmarked', newIsBookmarked);
                
                // Update icon and aria-label based on new state
                const isCompactView = originalClasses.includes('text-white') ||
                                     originalClasses.includes('text-fuchsia-300');
                
                const iconMap = {
                    add: { icon: 'fas', compact: 'text-fuchsia-300', normal: 'text-fuchsia-400' },
                    remove: { icon: 'far', compact: 'text-white', normal: 'text-gray-400' }
                };
                
                const action = newIsBookmarked ? 'add' : 'remove';
                const colorClass = isCompactView ? iconMap[action].compact : iconMap[action].normal;
                const colorPattern = isCompactView ? /\btext-(white|fuchsia-\d+)\b/ : /\btext-(gray|fuchsia)-\d+\b/;
                
                const newClasses = originalClasses
                    .replace(/\b(far|fas)\b/, iconMap[action].icon)
                    .replace(colorPattern, colorClass);
                
                $icon.attr('class', newClasses);
                
                // Update aria-label
                const currentLabel = $btn.attr('aria-label') || '';
                if (currentLabel) {
                    const [oldText, newText] = newIsBookmarked 
                        ? ['Add bookmark for', 'Remove bookmark for']
                        : ['Remove bookmark for', 'Add bookmark for'];
                    $btn.attr('aria-label', currentLabel.replace(oldText, newText));
                }
                
                // Visual feedback handled by icon change
            } else {
                // Restore original state on error
                $icon.attr('class', originalClasses);
                console.error('Bookmark toggle failed:', response.error_msg || 'Unknown error');
                
                // Show alert if there's an error message
                if (response.error_msg) {
                    alert(response.error_msg);
                }
            }
        })
        .fail(function(xhr, status, error) {
            // Restore original state on error
            $icon.attr('class', originalClasses);
            console.error('Bookmark toggle request failed:', error);
            
            // Error already logged to console
        })
        .always(function() {
            // Re-enable button
            $btn.prop('disabled', false);
        });
        });
    } else if (checkReadyRetryCount < CHECK_READY_MAX_RETRIES) {
        checkReadyRetryCount++;
        setTimeout(checkReady, 50);
    } else {
        console.error('[Search.js] Failed to initialize: jQuery not available after ' + (CHECK_READY_MAX_RETRIES * 50) + 'ms');
    }
})();
